/* esm.sh - d3-transition@3.0.1/src/transition/attr */
export * from "/*d3-transition@3.0.1/esnext/src/transition/attr.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/attr.mjs";
